import { render, staticRenderFns } from "./SupportTicketList.vue?vue&type=template&id=603f48b5"
import script from "./SupportTicketList.vue?vue&type=script&lang=js"
export * from "./SupportTicketList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports